import { css, Theme } from "@emotion/react";
import { t } from "i18next";
import { theme } from "styles/theme";

export const LogoAuthStyle = {
  logoApp: ({ colors }: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    margin-bottom: 12px;
    position: relative;

    img {
      width: 110px;
    }

    span {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      color: ${theme.colors.darkGreen};
      margin-top: 8px;
      text-align: center;
    }
  `,
};
